import React, { useMemo } from 'react';
import {
	Meta,
	useTermItemsQuery,
	useWorkerInformationQuery,
} from '../../../../../graphql/graphql';
// @ts-ignore
import styles from './WorkerDetail.module.scss';
import Loading from '../../../../../Components/Loading';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	userId: string;
}

interface useDataItem {
	title: string;
	value?: string;
}

const WorkerDetail: React.FC<Props> = ({ userId }) => {
	const { t } = useTranslation();

	const { data, isLoading } = useWorkerInformationQuery({
		userId,
	});

	const profession = useTermItemsQuery({
		termType: 'md_profession',
		take: 999,
	});

	const docTypes = useTermItemsQuery({
		termType: 'identification_document_type',
		take: 999,
	});

	const doctorSpecialization = useTermItemsQuery({
		termType: 'md_specialization',
		take: 999,
	});

	const nurseSpecialization = useTermItemsQuery({
		termType: 'md_nurse_specialization',
		take: 999,
	});

	const findSpecializationKeyInMeta = (lookingForKey: string, data: Meta[]) => {
		return data
			?.find(({ key }: any) => key === lookingForKey)
			?.value?.toString();
	};

	const userData: useDataItem[] = useMemo(() => {
		const professionCode =
			data?.user?.meta?.find(({ key }: any) => key === 'profession')?.value ??
			'';

		const identificationDocumentTypeKey = data?.user?.meta?.find(
			({ key }: any) => key === 'identificationDocumentType',
		)?.value;

		return [
			{
				title: 'component.workerDetail.nationality',
				value: data?.user?.profile?.nationalityTermItem?.name,
			},
			{
				title: 'component.workerDetail.identificationDocumentType',
				value: docTypes?.data?.termItems?.data?.find(
					item => item?.value === identificationDocumentTypeKey,
				)?.name,
			},
			{
				title: 'component.workerDetail.identificationDocumentNumber',
				value: data?.user?.meta?.find(
					({ key }: any) => key === 'identificationDocumentNumber',
				)?.value,
			},
			{
				title: 'component.workerDetail.profession',
				value: profession?.data?.termItems?.data?.find(
					(item: any) => item.value === professionCode?.toString(),
				)?.name,
			},
			{
				title: 'component.workerDetail.specialization',
				value: nurseSpecialization?.data?.termItems?.data?.find(
					(item: any) =>
						item.value ===
						findSpecializationKeyInMeta(
							'specialityNurse',
							data?.user?.meta as Meta[],
						),
				)?.name,
			},
			{
				title: 'component.workerDetail.specialization',
				value: doctorSpecialization?.data?.termItems?.data?.find(
					(item: any) =>
						item.value ===
						findSpecializationKeyInMeta(
							'specialityDoctor',
							data?.user?.meta as Meta[],
						),
				)?.name,
			},
			{
				title: 'component.workerDetail.subSpecialization',
				value: data?.user?.meta?.find(
					({ key }: any) => key === 'subSpecialization',
				)?.value,
			},
		];
	}, [profession, doctorSpecialization, nurseSpecialization, docTypes, data]);

	if (isLoading || profession.isLoading || docTypes.isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{userData.map((item, key) => {
				if (item.value) {
					return (
						<div className={styles.item} key={key}>
							<span>{t(item.title)}:</span> {item.value}
						</div>
					);
				}
			})}
		</div>
	);
};

export default WorkerDetail;
